// extracted by mini-css-extract-plugin
module.exports = {"seachBlock":"styles_seachBlock__sEylh","seachBlock__dandruff":"styles_seachBlock__dandruff__2BHXD","seachBlock__button":"styles_seachBlock__button__1zPBS"};